import { ModalCash } from 'components/features/pfm/RewardDetails/ModalCash'
import { ModalCrypto } from 'components/features/pfm/RewardDetails/ModalCrypto'
import { FC, ReactElement } from 'react'

type ModalProps = {
  rewardType: 'crypto' | 'cash'
  onCloseClick: () => void
}

export const Modal: FC<ModalProps> = ({
  rewardType,
  onCloseClick,
}): ReactElement => {
  switch (rewardType) {
    case 'crypto':
      return <ModalCrypto onCloseClick={ onCloseClick } />
    default:
      return <ModalCash onCloseClick={ onCloseClick } />
  }
}
